<div class="ap-wrap">
	<div class="imgmap-frontend-image">
		<div class="home-imagemap-head-bg"></div>
    <div style="display: block; position: relative;">
      <img
        [src]="agency.map_plan.url"
        usemap="#ap-map"
        id="ap-img"
        class="ap-img"
        loading="lazy"
      >
    </div>
		<map name="ap-map">
      <area
				*ngFor="let project of projects, trackBy: listTrackingService.disableUpdate"
        data-type="link"
				[href]="(basePath == '/' ? '' : basePath) + '/bloc/' + project.id"
        [attr.data-tooltip]="project.name"
        data-fill-color="E4BD62"
        data-fill-opacity="0.5"
        data-stroke-color="fefefe"
        data-stroke-opacity="0.8"
        data-stroke-width="2"
        [attr.data-mapkey]="'area-' + project.id"
        shape="poly"
        [attr.coords]="project.area.join(',')"
      >
		</map>
	</div>
</div>



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/map-plan/map-plan-project-base.component.html